import { useEffect, useState } from 'react';
import type { HealthResponse } from '@starter/shared';
import { api } from '../api/client.js';

export function HealthBadge() {
  const [health, setHealth] = useState<HealthResponse | null>(null);

  useEffect(() => {
    api
      .health()
      .then(setHealth)
      .catch(() => setHealth(null));
  }, []);

  if (!health) {
    return (
      <div className="health health--unknown" data-testid="health-badge">
        <span className="health-dot" />
        API
      </div>
    );
  }

  const ok = health.status === 'ok';
  return (
    <div className={`health health--${ok ? 'ok' : 'degraded'}`} data-testid="health-badge">
      <span className="health-dot" />
      {health.status}
      <span className="health-meta">
        db {health.checks.database.status}
        {health.checks.database.latencyMs !== null && ` · ${health.checks.database.latencyMs}ms`}
      </span>
    </div>
  );
}
